export default __webpack_public_path__ + "c473a68778f12f81400d651525ac3583.png";